<template>
  <div class="">
    <el-form :model="invoice" label-position="left" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
      <el-form-item label="发票单号" prop="invoice_number">
        <el-input v-model="invoice.invoice_number" placeholder="请输入快递单号"></el-input>
      </el-form-item>
      <el-form-item label="上传发票" prop="invoice_img">
        <SelectImgs :selectNum="1" :selectData="[invoice.invoice_img]" :selectFunc="imgChoose"></SelectImgs>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">上传发票</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import SelectImgs from '@/components/SelectImgs'
export default {
  data() {
    return {
      invoice: {
        id: 0,
        invoice_number: '',
        invoice_img: '',
      },
      rules: {
        invoice_number: [
          { required: true, message: '请填写发票单号', trigger: 'blur' }
        ],
        invoice_img: [
          { required: true, message: '请上传发票', trigger: 'blur' }
        ]
      },
    }
  },
  components: {
    SelectImgs
  },
  props: {
    id: Number,
    callback: Function
  },
  watch: {
    'id': {
      handler (newValue, oldValue) {
        this.invoice.id = newValue
        this.invoice.invoice_img = ''
        this.invoice.invoice_number = ''
      },
      deep: true,
      immediate: true
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    imgChoose(item) {
      this.invoice.invoice_img = item.pic
    },
    submitForm() {
      var _this = this
      var params = this.invoice
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          _this.showLoading()
          _this.$api.order.financeInvoiceIssue(params, res => {
            _this.hideLoading()
            if (res.errcode == 0) {
              _this.success(res.errmsg)
              _this.callback()
            } else {
              _this.fail(res.errmsg)
            }
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
</style>
